import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

let isForceLoggingOut = false;

// auto token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (token && tokenType) {
    config.headers.Authorization = `${tokenType} ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    if (response.data?.message === 'Unauthenticated') {
      window.dispatchEvent(new Event("forceLogout"));
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const responseData = error.response;
    //handle 401
    if (status === 401) {
      if (!isForceLoggingOut) {
        console.warn("[API] 401 detected → force logout");

        isForceLoggingOut = true;
        window.dispatchEvent(new Event("forceLogout"));

        setTimeout(() => {
          isForceLoggingOut = false;
        }, 1000);
      }
    }
    //handle errors 400, 422, 403, 500
    return Promise.resolve(responseData);

  }

);

export default api;
